export enum OpenBankingProvider {
  GOCARDLESS = 'gocardless',
  UNIVERSAL_SANDBOX = 'universal-sandbox',
  NATWEST_PAYIT = 'natwest-payit',
  YAPILY = 'yapily',
  BOTTOMLINE = 'bottomline',
}
